import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormService } from '../../../common/services/form.service';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { FormCommonDataService } from '../../../common/services/form-common-data.service';
import { UserService } from 'src/sb-tools/typescript/services/user.service';
import { combineLatest, Subject, take, takeUntil } from 'rxjs';
import { TypeaheadMatch, TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { FormType } from '@sb-tools/typescript/enums/form-type.enum';
import { ClientField } from '../../../common/models/client-field.model';
import { ContactService } from '@sb-tools/typescript/services/contact.service';
import { AddressBookContactDTO } from '@sb-tools/typescript/models/dto/address-book-contact.dto';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BaseUserWithRole } from '@sb-tools/typescript/models/base-user-with-role.model';
import { FocusDirective } from '@sb-tools/typescript/directives/focus.directive';
import { InlineSVGComponent } from '../../../../Frontend-Inline-SVG-Module/inline-svg.component';
import { UserAvatarComponent } from '../../../../Frontend-User-Avatar-Module/user-avatar.component';
import { TruncatePipe } from '@sb-tools/typescript/pipes/truncate.pipe';
import { FormFieldLabelComponent } from '@form-field-module/common/components/form-field-label/form-field-label.component';
import { NgTemplateOutlet } from '@angular/common';
import { EmailValidatorDirective } from '@form-field-module/common/directives/email-validator.directive';

declare let FB: any;

@Component({
    selector: 'sb-user-identification',
    templateUrl: './user-identification.component.html',
    styleUrls: ['./user-identification.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [
        FocusDirective,
        FormsModule,
        InlineSVGComponent,
        TranslateModule,
        UserAvatarComponent,
        TruncatePipe,
        TypeaheadModule,
        FormFieldLabelComponent,
        NgTemplateOutlet,
        EmailValidatorDirective,
    ],
})
export class UserIdentificationComponent implements OnInit, OnDestroy {
    @Input() formField: Field | ClientField;
    @Input() formType: FormType;

    @ViewChild('field') field: any;

    allUsers: (BaseUserWithRole | AddressBookContactDTO)[] = [];
    isFBEnabled: boolean;
    isReadOnlyField: boolean;
    isTypeahead: boolean;

    private user: any;
    private unsubscriber = new Subject<void>();

    constructor(
        public formService: FormService,
        public formCommonDataService: FormCommonDataService,
        private contactService: ContactService,
        private cdr: ChangeDetectorRef,
        private userService: UserService,
        private translateService: TranslateService,
    ) {}

    ngOnInit() {
        this.isTypeahead = this.formType === FormType.webInternal || this.formType === FormType.inboxForwardForm;
        this.isReadOnlyField = this.formType === FormType.outlook;
        this.isFBEnabled =
            this.formType !== FormType.webInternal &&
            this.formField.options?.includeFBAuth === 'true' &&
            this.formCommonDataService.customerSettings?.isGAEnabled;

        if (this.isTypeahead) {
            combineLatest([this.contactService.getAllFromCache(), this.userService.getAll()])
                .pipe(takeUntil(this.unsubscriber), take(1))
                .subscribe(([contacts, users]) => {
                    contacts.forEach((contact) => {
                        contact.label = contact.name + ' ' + contact.email;
                        contact.typeName = this.translateService.instant('Contacts');
                        contact.isContact = true;
                    });
                    users.forEach((user) => {
                        user.label = user.name ? user.name + ' ' + user.email : user.email;
                        user.typeName = this.translateService.instant('Teammates');
                    });

                    this.allUsers = [...contacts, ...users];
                });
        }

        if (this.formCommonDataService.customerSettings?.isGAEnabled) {
            this.loadFacebook();
        }
    }

    addUser(event: TypeaheadMatch) {
        this.formField.value = event.item.email;
    }

    login() {
        FB.login(
            (response) => {
                if (response.authResponse) {
                    this.me();
                }
            },
            { scope: 'email' },
        );
    }

    private me() {
        FB.api('/me?fields=name,email', (response) => {
            if (response && !response.error) {
                this.user = response;
                setTimeout(() => {
                    this.field.control.setValue(this.user.email);
                    this.formField.value = this.user.email;
                    this.cdr.detectChanges();
                }, 100);
            }
        });
    }

    private loadFacebook() {
        /* eslint-disable */
        (window as any).fbAsyncInit = () => {
            FB.init({
                appId: '252226198148397',
                xfbml: true,
                version: 'v3.1',
            });
            // FB.AppEvents.logPageView();
        };

        ((d, s, id) => {
            let js;
            const fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = 'https://connect.facebook.net/en_US/sdk.js';
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
        /* eslint-enable */
    }

    private isLoggedIn() {
        FB.getLoginStatus((response) => {
            return response.status === 'connected';
        });
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
